// src/pages/exercise/components/Character/CharacterManager.jsx
import React, { useRef } from 'react';
import { CharacterVisuals } from './CharacterVisuals';
import { AnimationManager } from './AnimationManager';
import { useStore } from '../Stores/exerciseStore';

export function CharacterManager({ groupRef }) {
  const { charIndex } = useStore();
  
  const internalGroupRef = useRef();

  return (
    <group ref={groupRef}>
      <group ref={internalGroupRef}>
        {/* ✅ Convert 1-based store index to 0-based array index */}
        <CharacterVisuals activeIndex={charIndex - 1} />
      </group>

      <AnimationManager targetRef={internalGroupRef} />
    </group>
  );
}
